import type { ProductSlimResponseDTO } from '@shared/DTO';
import { PRODUCT_RATING_LABELS } from '@shared/values';
import { resolveProductImageUrl } from '@/scripts/utils/productImage.utils';

export interface ProductAspect { label: string; score: number; }
export interface ProductContentImage { url: string; alt: string; }
export interface ProductContent {
  title?: string;
  image?: ProductContentImage;
  descriptionPoints?: readonly string[];
  pros?: readonly string[];
  cons?: readonly string[];
  aspects?: readonly ProductAspect[];
}
/** Undefined inherits the product default; null hides; supplied values replace it. */
export type ProductContentInputs = { [K in keyof ProductContent]?: ProductContent[K] | null };

function contentValue<T>(base: T, input?: T | null): T | undefined {
  return input === undefined ? base : input === null ? undefined : input;
}

export function resolveProductContent(product: ProductSlimResponseDTO, inputs: ProductContentInputs = {}): ProductContent {
  const data = product.productData;
  const url = resolveProductImageUrl(data.images?.[0]?.image?.sizes?.[0]?.url);
  return {
    title: contentValue(data.names[0], inputs.title),
    image: contentValue(url ? { url, alt: data.names[0] } : undefined, inputs.image),
    descriptionPoints: contentValue(data.descriptionPoints, inputs.descriptionPoints),
    pros: contentValue(data.pros, inputs.pros),
    cons: contentValue(data.cons, inputs.cons),
    aspects: contentValue((data.ratings ?? []).map(({ key, score }) => ({ label: PRODUCT_RATING_LABELS[key], score })), inputs.aspects),
  };
}
